import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';


const Wrapper = ({title, loading, titleControls, user, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading} controls={titleControls}/>
      <Notice
        display={user && user.archived}
        message={[
          'This engineer has been archived and is therefore no longer available.',
          'You won\'t be able to modify them unless they are restored.'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['engineer']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Engineers', link: reverse(routes.engineers.index)}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: reverse(routes.archive.index)},
  {title: 'Engineers', link: reverse(routes.archive.index, {tab: 'engineers'})}
];

export default Wrapper;
